<div id="breadcrumb-bar" class="breadcrumb-bar">
  <ul class="breadcrumb">
    @for (breadcrumb of breadcrumbs; track breadcrumb) {
      <li>
        @if (breadcrumb.url) {
          <a [routerLink]="breadcrumb.url" [ixTest]="['breadcrumb', breadcrumb.breadcrumb]">
            {{ breadcrumb.breadcrumb | translate }}
          </a>
        } @else {
          <span>{{ breadcrumb.breadcrumb | translate }}</span>
        }
      </li>
    }
  </ul>
</div>
